import React from "react";

/**
 * Иконки кабинета Рублокса — заменяют ВСЕ эмодзи во внутренней части сайта.
 * Все нарисованы в едином стиле: viewBox 24×24, обводка currentColor,
 * stroke-width 1.8, скруглённые концы. Цвет наследуется от текста.
 *
 * Использование:  <CabIcon name="trophy" size={18} />
 */

const ST = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};
const FILL = { fill: "currentColor", stroke: "none" };

const ICONS = {
  /* ── навигация / общее ──────────────────────────────────────── */
  home: () => (
    <>
      <path d="M4 11.5 12 4l8 7.5" {...ST} />
      <path d="M6 10.5V19a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-8.5" {...ST} />
      <path d="M10 20v-5h4v5" {...ST} />
    </>
  ),
  trophy: () => (
    <>
      <path d="M7 4h10v4a5 5 0 0 1-10 0V4Z" {...ST} />
      <path d="M7 6H4.5v1.5A3 3 0 0 0 7.5 10M17 6h2.5v1.5A3 3 0 0 1 16.5 10" {...ST} />
      <path d="M12 13v3M9 20h6M10 20c0-1.5.5-2.5 2-2.5s2 1 2 2.5" {...ST} />
    </>
  ),
  userCircle: () => (
    <>
      <circle cx="12" cy="12" r="8.5" {...ST} />
      <circle cx="12" cy="10" r="3" {...ST} />
      <path d="M6.5 18.5a6 6 0 0 1 11 0" {...ST} />
    </>
  ),
  users: () => (
    <>
      <circle cx="9" cy="8.5" r="3" {...ST} />
      <path d="M3.5 19a5.5 5.5 0 0 1 11 0" {...ST} />
      <path d="M15.5 6a3 3 0 0 1 0 5.5M16 13.5a5.5 5.5 0 0 1 4.5 5.5" {...ST} />
    </>
  ),
  user: () => (
    <>
      <circle cx="12" cy="8" r="3.5" {...ST} />
      <path d="M5 20a7 7 0 0 1 14 0" {...ST} />
    </>
  ),
  more: () => (
    <>
      <circle cx="5.5" cy="12" r="1.4" {...FILL} />
      <circle cx="12" cy="12" r="1.4" {...FILL} />
      <circle cx="18.5" cy="12" r="1.4" {...FILL} />
    </>
  ),
  back: () => <path d="M15 5 8 12l7 7" {...ST} />,
  image: () => (
    <>
      <rect x="3.5" y="5" width="17" height="14" rx="2.5" {...ST} />
      <circle cx="9" cy="10" r="1.6" {...ST} />
      <path d="M3.5 16.5 8.5 12l4 4 3-2.5 5 4" {...ST} />
    </>
  ),
  pencil: () => (
    <>
      <path d="M4 20l1.2-4.8L16.4 4a2.3 2.3 0 0 1 3.3 0l.3.3a2.3 2.3 0 0 1 0 3.3L8.8 18.8Z" {...ST} />
      <path d="M14.5 6.5l3 3" {...ST} />
    </>
  ),
  /* фон страницы профиля: пейзаж во весь кадр + уголки «на весь экран» */
  wallpaper: () => (
    <>
      <rect x="3" y="4.5" width="18" height="15" rx="2.5" {...ST} />
      <path d="M3 15.5 8 10.5l4 4.5 3.2-3 5.8 5" {...ST} />
      <circle cx="15.5" cy="9" r="1.5" {...ST} />
      <path d="M6.5 4.5v-2m11 2v-2M6.5 19.5v2m11-2v2" {...ST} />
    </>
  ),
  star: () => (
    <path d="M12 3.5l2.5 5.3 5.8.7-4.3 4 1.1 5.7L12 16.4l-5.1 2.8 1.1-5.7-4.3-4 5.8-.7L12 3.5Z" {...ST} />
  ),
  gift: () => (
    <>
      <rect x="4" y="10" width="16" height="10" rx="1.5" {...ST} />
      <path d="M3.5 6.5h17v3.5h-17Z" {...ST} />
      <path d="M12 6.5v13.5" {...ST} />
      <path d="M12 6.5C10 3.5 6.5 3.8 6.8 5.7c.2 1.4 3 1.2 5.2.8Zm0 0c2-3 5.5-2.7 5.2-.8-.2 1.4-3 1.2-5.2.8Z" {...ST} />
    </>
  ),
  arrowRight: () => <path d="M9 5l7 7-7 7" {...ST} />,
  globe: () => (
    <>
      <circle cx="12" cy="12" r="8.5" {...ST} />
      <path d="M3.5 12h17M12 3.5c2.5 2.4 2.5 14.6 0 17M12 3.5c-2.5 2.4-2.5 14.6 0 17" {...ST} />
    </>
  ),
  exit: () => (
    <>
      <path d="M14 4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8" {...ST} />
      <path d="M11 12h9M16.5 8 20.5 12l-4 4" {...ST} />
    </>
  ),
  close: () => <path d="M6 6 18 18M18 6 6 18" {...ST} />,
  check: () => <path d="M5 12.5 10 17.5 19 7" {...ST} />,
  search: () => (
    <>
      <circle cx="11" cy="11" r="6.5" {...ST} />
      <path d="M16 16l4.5 4.5" {...ST} />
    </>
  ),
  // воронка — фильтры каталога
  filter: () => <path d="M4 5h16l-6.2 7.2V19l-3.6 1.8v-8.6L4 5Z" {...ST} />,
  // плюс/минус — шаговые кнопки (степпер конвертации в кошельке).
  // Текстовые «+» и «−» в кнопках выглядели как опечатка: они наследуют
  // кегль шрифта и не выравниваются по центру круглой кнопки.
  plus: () => <path d="M12 5v14M5 12h14" {...ST} />,
  minus: () => <path d="M5 12h14" {...ST} />,
  send: () => (
    <path
      d="M4 12 20 4 14 20l-3-7-7-1Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
      fill="currentColor"
    />
  ),
  warning: () => (
    <>
      <path d="M12 4 21 19H3L12 4Z" {...ST} />
      <path d="M12 10v4" {...ST} />
      <circle cx="12" cy="16.6" r="0.4" {...FILL} />
    </>
  ),
  construction: () => (
    <>
      <rect x="3.5" y="9" width="17" height="6" rx="1" {...ST} />
      <path d="M6 9 9 15M11 9 14 15M16 9 19 15" {...ST} />
      <path d="M5 9V6.5h14V9M5 15v2.5h14V15" {...ST} />
    </>
  ),

  /* ── экономика / игра ───────────────────────────────────────── */
  diamond: () => (
    <>
      <path d="M6 4h12l3 4.5-9 11.5L3 8.5 6 4Z" {...ST} />
      <path d="M3 8.5h18M9 4 7.5 8.5 12 20M15 4l1.5 4.5L12 20" {...ST} />
    </>
  ),
  heart: () => (
    <path
      d="M12 20s-7-4.3-7-9.4A4.1 4.1 0 0 1 12 7.6 4.1 4.1 0 0 1 19 10.6c0 5.1-7 9.4-7 9.4Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
      fill="currentColor"
    />
  ),
  heartBroken: () => (
    <>
      <path
        d="M12 20s-7-4.3-7-9.4A4.1 4.1 0 0 1 12 7.6 4.1 4.1 0 0 1 19 10.6c0 5.1-7 9.4-7 9.4Z"
        {...ST}
      />
      <path d="M12 7.5 10 11l3 2-2 3.5" {...ST} />
    </>
  ),
  play: () => (
    <path
      d="M8 5.5 18 12 8 18.5z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
      fill="currentColor"
    />
  ),
  eye: () => (
    <>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" {...ST} />
      <circle cx="12" cy="12" r="3" {...ST} />
    </>
  ),
  gamepad: () => (
    <>
      <path
        d="M7 8h10a4 4 0 0 1 4 4v.6c0 2-1.2 3.9-3.4 3.9-1.5 0-2.1-1-3-2.2-.4-.5-.9-.8-1.6-.8h-2c-.7 0-1.2.3-1.6.8-.9 1.2-1.5 2.2-3 2.2C3.7 16.5 2.5 14.6 2.5 12.6V12a4 4 0 0 1 4-4Z"
        {...ST}
      />
      <path d="M7.5 11v2.4M6.3 12.2h2.4" {...ST} />
      <circle cx="15.7" cy="11.4" r="1" {...FILL} />
      <circle cx="17.6" cy="13.2" r="1" {...FILL} />
    </>
  ),
  fire: () => (
    <path
      d="M12 3c.5 3-2 4-2 7a2 2 0 0 0 4 0c0-.8-.3-1.4-.3-1.4 1.8 1 3.3 2.8 3.3 5.4a5 5 0 0 1-10 0c0-3.6 3-5.5 3-8 0 0 3 .5 5-.4Z"
      {...ST}
    />
  ),
  crown: () => (
    <>
      <path d="M4 17 3 7l5 4 4-6 4 6 5-4-1 10H4Z" {...ST} />
      <path d="M4 19.5h16" {...ST} />
    </>
  ),
  rocket: () => (
    <>
      <path d="M12 3c3.5 1.8 5.5 5 5.5 9l-2.3 2.3H8.8L6.5 12C6.5 8 8.5 4.8 12 3Z" {...ST} />
      <circle cx="12" cy="9" r="1.6" {...ST} />
      <path d="M8.8 14.3 6.5 16.5M15.2 14.3l2.3 2.2" {...ST} />
      <path d="M9.5 17c-1 .6-1.7 1.9-1.8 4 2.1-.1 3.4-.8 4-1.8M14.5 17c1 .6 1.7 1.9 1.8 4-2.1-.1-3.4-.8-4-1.8" {...ST} />
    </>
  ),
  sparkles: () => (
    <>
      <path d="M12 4l1.6 4.4L18 10l-4.4 1.6L12 16l-1.6-4.4L6 10l4.4-1.6L12 4Z" {...ST} />
      <path d="M18.5 14.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7.7-1.8Z" {...ST} />
    </>
  ),
  liveDot: () => (
    <>
      <circle cx="12" cy="12" r="4" {...FILL} />
      <circle cx="12" cy="12" r="8" {...ST} opacity="0.5" />
    </>
  ),
  cart: () => (
    <>
      <path d="M3 4h2.5l2.2 10.5a1 1 0 0 0 1 .8h7.6a1 1 0 0 0 1-.8L19 7H6" {...ST} />
      <circle cx="9.5" cy="19" r="1.3" {...ST} />
      <circle cx="16.5" cy="19" r="1.3" {...ST} />
    </>
  ),

  /* ── жанры игр ──────────────────────────────────────────────── */
  jump: () => (
    <>
      <circle cx="12" cy="5.5" r="2.2" {...ST} />
      <path d="M12 8v5M12 13l-3 5M12 13l3 5M9 10l-3-1.5M15 10l3-1.5" {...ST} />
    </>
  ),
  gun: () => (
    <>
      <path d="M3 8h13v4h-3l-1 3H8l-1-3H3V8Z" {...ST} />
      <path d="M16 8h5v3h-3M7 12v3" {...ST} />
    </>
  ),
  ghost: () => (
    <>
      <path d="M5 20v-9a7 7 0 0 1 14 0v9l-2.3-1.6L14.3 20 12 18.4 9.7 20l-2.4-1.6L5 20Z" {...ST} />
      <circle cx="9.5" cy="10.5" r="1" {...FILL} />
      <circle cx="14.5" cy="10.5" r="1" {...FILL} />
    </>
  ),
  puzzle: () => (
    <path
      d="M10 4h4v2.2a1.5 1.5 0 1 0 3 0V4h3v3.5h-2.2a1.5 1.5 0 1 0 0 3H20v3.5h-3v-2.2a1.5 1.5 0 1 0-3 0V17h-4v-2.5H7.8a1.5 1.5 0 1 0 0-3H10V8H7.8a1.5 1.5 0 1 1 0-3H10V4Z"
      {...ST}
    />
  ),
  car: () => (
    <>
      <path d="M3 14l1.8-5a2 2 0 0 1 1.9-1.4h8.6A2 2 0 0 1 19 9l1.8 5M3 14h18M3 14v3.5h2.5V14M21 14v3.5h-2.5V14" {...ST} />
      <circle cx="7.5" cy="14" r="1.6" {...ST} />
      <circle cx="16.5" cy="14" r="1.6" {...ST} />
    </>
  ),
  map: () => (
    <>
      <path d="M9 4 4 6v14l5-2 6 2 5-2V4l-5 2-6-2Z" {...ST} />
      <path d="M9 4v14M15 6v14" {...ST} />
    </>
  ),
  swords: () => (
    <>
      <path d="M14.5 4H20v5.5l-9 9-3-3 9-9V4H14.5L4 14.5" {...ST} opacity="0" />
      <path d="M4 4h3l11 11v3h-3L4 7V4Z" {...ST} />
      <path d="M20 4h-3L6 15v3h3L20 7V4Z" {...ST} />
    </>
  ),
  target: () => (
    <>
      <circle cx="12" cy="12" r="8" {...ST} />
      <circle cx="12" cy="12" r="4.5" {...ST} />
      <circle cx="12" cy="12" r="1.2" {...FILL} />
    </>
  ),
  dice: () => (
    <>
      <rect x="4" y="4" width="16" height="16" rx="3" {...ST} />
      <circle cx="8.5" cy="8.5" r="1.1" {...FILL} />
      <circle cx="15.5" cy="8.5" r="1.1" {...FILL} />
      <circle cx="12" cy="12" r="1.1" {...FILL} />
      <circle cx="8.5" cy="15.5" r="1.1" {...FILL} />
      <circle cx="15.5" cy="15.5" r="1.1" {...FILL} />
    </>
  ),

  /* ── друзья / чат ───────────────────────────────────────────── */
  chat: () => (
    <path
      d="M4 5h16a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9l-4 4v-4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"
      {...ST}
    />
  ),
  inbox: () => (
    <>
      <path d="M3.5 13 6 5h12l2.5 8v6a1 1 0 0 1-1 1H4.5a1 1 0 0 1-1-1v-6Z" {...ST} />
      <path d="M3.5 13H8l1.5 2.5h5L16 13h4.5" {...ST} />
    </>
  ),
  shrug: () => (
    <>
      <circle cx="12" cy="7" r="3" {...ST} />
      <path d="M12 10v5M12 12l-4 1M12 12l4 1M8 13l-2 3M16 13l2 3M8 18l-1.5 2M16 18l1.5 2" {...ST} />
    </>
  ),
  wave: () => (
    <>
      <circle cx="12" cy="7" r="3" {...ST} />
      <path d="M9.5 11.5 7 14M14.5 11.5 17 14M12 10v6" {...ST} />
      <path d="M16.5 6.5c1.2-.6 2.3-.4 3 .5M7.5 6.5c-1.2-.6-2.3-.4-3 .5" {...ST} />
    </>
  ),

  /* ── настройки / about ──────────────────────────────────────── */
  gear: () => (
    <>
      <circle cx="12" cy="12" r="3" {...ST} />
      <path d="M12 2.5v3M12 18.5v3M21.5 12h-3M5.5 12h-3M19 5l-2.1 2.1M7.1 16.9 5 19M19 19l-2.1-2.1M7.1 7.1 5 5" {...ST} />
    </>
  ),
  info: () => (
    <>
      <circle cx="12" cy="12" r="8.5" {...ST} />
      <path d="M12 11v5.5" {...ST} />
      <circle cx="12" cy="7.8" r="0.5" {...FILL} />
    </>
  ),
  flag: () => (
    <>
      <path d="M6 3v18" {...ST} />
      <path d="M6 4h11l-2 3.5L17 11H6V4Z" {...ST} />
    </>
  ),
  robot: () => (
    <>
      <rect x="5" y="8" width="14" height="11" rx="2.5" {...ST} />
      <path d="M12 4v4M12 4h-1.5M12 4h1.5" {...ST} />
      <circle cx="9.5" cy="13" r="1.2" {...FILL} />
      <circle cx="14.5" cy="13" r="1.2" {...FILL} />
      <path d="M9.5 16h5M2.5 12v3M21.5 12v3" {...ST} />
    </>
  ),
  book: () => (
    <>
      <path d="M5 4h11a2 2 0 0 1 2 2v14H7a2 2 0 0 1-2-2V4Z" {...ST} />
      <path d="M5 18a2 2 0 0 1 2-2h11" {...ST} />
      <path d="M9 8h6M9 11h6" {...ST} />
    </>
  ),
  chart: () => (
    <>
      <path d="M4 4v16h16" {...ST} />
      <path d="M8 16v-4M12 16V8M16 16v-7" {...ST} />
    </>
  ),
  museum: () => (
    <>
      <path d="M3 9 12 4l9 5" {...ST} />
      <path d="M5 9.5V18M9.5 9.5V18M14.5 9.5V18M19 9.5V18" {...ST} />
      <path d="M3 18h18M3.5 21h17" {...ST} />
    </>
  ),
  calendar: () => (
    <>
      <rect x="4" y="5.5" width="16" height="15" rx="2" {...ST} />
      <path d="M4 9.5h16M8.5 3v4M15.5 3v4" {...ST} />
    </>
  ),
  refresh: () => (
    <>
      <path d="M20 11a8 8 0 0 0-14.3-4.5M4 5v3.5h3.5" {...ST} />
      <path d="M4 13a8 8 0 0 0 14.3 4.5M20 19v-3.5h-3.5" {...ST} />
    </>
  ),
  palette: () => (
    <>
      <path d="M12 3a9 9 0 0 0 0 18c1.4 0 1.8-1 1.4-1.9-.5-1 .2-2.1 1.3-2.1H17a4 4 0 0 0 4-4c0-5-4-10-9-10Z" {...ST} />
      <circle cx="8" cy="11" r="1" {...FILL} />
      <circle cx="12" cy="8" r="1" {...FILL} />
      <circle cx="16" cy="11" r="1" {...FILL} />
    </>
  ),
  speaker: () => (
    <>
      <path d="M4 9.5h3.5L13 5v14L7.5 14.5H4v-5Z" {...ST} />
      <path d="M16 9.5a3.5 3.5 0 0 1 0 5M18.5 7a7 7 0 0 1 0 10" {...ST} />
    </>
  ),
  lock: () => (
    <>
      <rect x="5" y="10.5" width="14" height="9.5" rx="2" {...ST} />
      <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" {...ST} />
      <circle cx="12" cy="15" r="1.3" {...FILL} />
    </>
  ),
  bell: () => (
    <>
      <path d="M7 16V11a5 5 0 0 1 10 0v5l1.5 2.5h-13L7 16Z" {...ST} />
      <path d="M10 19a2 2 0 0 0 4 0" {...ST} />
    </>
  ),
  shield: () => (
    <>
      <path d="M12 3 5 6v6c0 4.5 3 7.5 7 9 4-1.5 7-4.5 7-9V6l-7-3Z" {...ST} />
      <path d="M9 12l2 2 4-4" {...ST} />
    </>
  ),
  school: () => (
    <>
      <path d="M12 4 2.5 8 12 12l9.5-4L12 4Z" {...ST} />
      <path d="M6 10v5c0 1.5 2.7 3 6 3s6-1.5 6-3v-5M21.5 8v5" {...ST} />
    </>
  ),
  question: () => (
    <>
      <circle cx="12" cy="12" r="8.5" {...ST} />
      <path d="M9.5 9.5a2.5 2.5 0 0 1 4.8.8c0 1.7-2.3 2-2.3 3.5" {...ST} />
      <circle cx="12" cy="16.6" r="0.5" {...FILL} />
    </>
  ),
  scroll: () => (
    <>
      <path d="M6 4h11a2 2 0 0 1 2 2v11a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V6" {...ST} />
      <path d="M4 6a2 2 0 0 1 4 0v11M9 9h7M9 12h7M9 15h4" {...ST} />
    </>
  ),

  /* ── медали (для лидербордов) ───────────────────────────────── */
  medal: () => (
    <>
      <circle cx="12" cy="14" r="6" {...ST} />
      <path d="M9 8.5 6.5 3M15 8.5 17.5 3M9 3h6" {...ST} />
      <path d="M12 11.5l1 2 2 .3-1.5 1.4.4 2-1.9-1-1.9 1 .4-2L9 13.8l2-.3 1-2Z" {...FILL} />
    </>
  ),
};

export default function CabIcon({ name, size = 20, className = "", ...rest }) {
  const render = ICONS[name];
  if (!render) return null;
  return (
    <svg
      className={`rb-cabicon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-hidden="true"
      {...rest}
    >
      {render()}
    </svg>
  );
}

/** Медаль с цветом по месту (1/2/3) — золото/серебро/бронза, иначе номер. */
export function PlaceMedal({ place, size = 20 }) {
  if (place > 3) {
    return <span className="rb-cabicon-place">{place}</span>;
  }
  const colors = { 1: "#fbbf24", 2: "#9ca3af", 3: "#d97706" };
  return (
    <span style={{ color: colors[place], display: "inline-flex" }}>
      <CabIcon name="medal" size={size} />
    </span>
  );
}
